export default "__VITE_ASSET__Dmz59C4l__"